module.exports = __webpack_public_path__ + "static/img/SearchDetailWork2.49f2c3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailWork2.png
// module id = 778
// module chunks = 0